import React from "react"
import { Container, Grid, Stack, Typography } from "@mui/material"

import { colors } from "@bullseye/tailwind-config"

const images = [
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/press-logos/nbc-lx-logo.png", alt: "NBC LX" },
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/press-logos/cbs-logo.png", alt: "CBS" },
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/techcrunch-logo.png", alt: "TechCrunch" },
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/aarp-innovation-labs-logo.png", alt: "AARP Innovation Labs" },
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/press-logos/prevention-logo.png", alt: "Prevention" },
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/fastco-logo.png", alt: "Fast Company" },
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/built-in-nyc-logo.png", alt: "Built In NYC" },
  { src: "https://storage.googleapis.com/hank-app-assets/marketing/entrepreneur-logo.png", alt: "Entrepreneur" },
]

const AsFeaturedIn = () => (
  <Stack style={{ width: "100%" }} py={10} px={2} gap={5}>
    <Typography
      variant={"h2"}
      color={colors.brand.indigo[1]}
      textAlign={"center"}
    >
      As Featured In
    </Typography>
    <Container maxWidth={"xl"} disableGutters>
      <Grid
        container
        gap={{ xs: 2, md: 5 }}
        justifyContent={{ xs: "center", md: "space-between" }}
      >
        {images.map((image, index) => (
          <Grid item key={index} flexBasis={"22%"}>
            <img width="208px" alt={image.alt} src={image.src} />
          </Grid>
        ))}
      </Grid>
    </Container>
  </Stack>
)

export default AsFeaturedIn
